app.Duplicate = (
    function () {
        var dupe = {
            //Index Page
            Init: function () {
                $("#duplicateVacancyButton").on("click", function () {
                    var id = $(this).attr("data-vacancy-id");
                    $.ajax({
                        type: "POST",
                        url: "/Employer/Vacancy/Duplicate",
                        data: {
                            id: 0,
                            duplicateId: id,
                            fromAddPage: false
                        },
                        success: function (response) {
                            if (response.success) {
                                var url = "/Employer/Vacancy/EditDuplicate";
                                window.location.href = url;
                            } else {
                                console.error("Error duplicating vacancy:", response.message);
                            }
                        },
                        error: function (xhr, status, error) {
                            // Handle error
                            console.error("Error duplicating vacancy:", status, error);
                        }
                    });
                });
            }
        };
        return dupe;
    }()
);